// extracted by mini-css-extract-plugin
export default {"card":"projects_card__253it","projectList":"projects_projectList__CLeaR"};